import {useNavigate} from 'react-router-dom';
import {
    FormPageLayout,
    SimplePageContentWrapper,
} from '@flexinet/ui-components';

import {RecordForm} from '../forms/RecordForm';
import {IndexPageNavigation} from '../navigation/IndexPageNavigation';
import {useTestingAction} from '../hooks/useTestingAction.ts';
import {
    ActionStatus,
    TestingAction,
} from '../types.ts';
import config from '../config';

export const AddPage = () => {

    const navigate = useNavigate();
    const onCancel = () => {
        navigate(config.basePath);
    };

    const {createRecord} = useTestingAction();

    const seededRecord = {status: ActionStatus.DRAFT} as TestingAction;

    const handleSubmit = async (values: TestingAction) => {
        await createRecord(values);
        navigate(config.basePath);
    };

    return (
        <FormPageLayout
            title={`Add ${config.titles.singular}`}
            pageNavigation={<IndexPageNavigation/>}
        >
            <SimplePageContentWrapper>
                <RecordForm
                    record={seededRecord}
                    handleSubmit={handleSubmit}
                    handleCancel={onCancel}
                />
            </SimplePageContentWrapper>
        </FormPageLayout>
    );
};
